var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.getWorkflowDefinitions}},[_vm._v("Refresh")]),_c('DataTable',{attrs:{"rowKeys":['name', 'version'],"rows":_vm.workflowDefinitions,"actions":_vm.readOnly
        ? [
            {
              name: 'workflowDefinition',
              label: 'View',
              params: {
                name: 'workflowDefinitionName',
                version: 'workflowDefinitionVersion'
              }
            }
          ]
        : [
            {
              name: 'workflowDefinition',
              label: 'View',
              params: {
                name: 'workflowDefinitionName',
                version: 'workflowDefinitionVersion'
              }
            },
            {
              name: 'workflowDefinitionEdit',
              label: 'Edit',
              params: {
                name: 'workflowDefinitionName',
                version: 'workflowDefinitionVersion'
              }
            }
          ],"columns":[
      { name: 'name', type: 'text' },
      { name: 'version', type: 'text' },
      { name: 'createTime', type: 'date' },
      { name: 'updateTime', type: 'date' }
    ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }